import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
